export default "__VITE_ASSET__Dob5oOa0__"